export const gallerySlides = [
  {
    original: './gallery/admission2026-gallery.png',
    mobileOriginal: './gallery/admission2026-gallery-mobile.png',
    eyebrowKey: 'gallery-eyebrow-2',
    titleKey: 'event-title-23',
    descriptionKey: 'gallery-description-4',
    buttonLabelKey: 'join-now',
    imagePosition: 'center 35%',
    mobileImagePosition: 'center 18%',
    to: 'https://forms.gle/hwT1DhjzaC9mP7kG6',
    isExternal: true,
  },
  {
    original: './gallery/gallery-1.jpg',
    eyebrowKey: 'gallery-eyebrow-1',
    titleKey: 'school',
    descriptionKey: 'gallery-description-1',
    to: '/about-history',
    isExternal: false,
  },
  {
    original: './gallery/gallery-2.jpg',
    eyebrowKey: 'gallery-eyebrow-2',
    titleKey: 'see-events',
    descriptionKey: 'gallery-description-2',
    to: '/events',
    isExternal: false,
  },
  {
    original: './gallery/gallery-3.jpg',
    eyebrowKey: 'gallery-eyebrow-3',
    titleKey: 'staff',
    descriptionKey: 'gallery-description-3',
    imagePosition: 'center 58%',
    to: '/about-faculty-and-staff',
    isExternal: false,
  },
];
